/**********************************************************************************************************
 *   BASE IMPORT
 **********************************************************************************************************/
import React from 'react'

/**********************************************************************************************************
 *   SHARED
 **********************************************************************************************************/
import { Loader } from 'nxui/src'

/**********************************************************************************************************
 *   UTILITIES
 **********************************************************************************************************/
import { useLightboxContext } from '../utilities'

/**********************************************************************************************************
 *   CONSTS
 **********************************************************************************************************/
import { LightboxBodyStyle as S } from './style'

/**********************************************************************************************************
 *   TYPE DEFINITIONS
 **********************************************************************************************************/
type TLightboxBody = React.FC<{
    children: React.ReactNode
    loadingMessage?: React.ReactNode
    ignoreLoading?: boolean
}>

/**********************************************************************************************************
 *   COMPONENT START
 **********************************************************************************************************/
export const LightboxBody: TLightboxBody = ({ children, loadingMessage, ignoreLoading }) => {
    /***** HOOKS *****/
    const { isLoading } = useLightboxContext()

    /***** RENDER *****/
    return (
        <S.Wrapper>
            <S.InnerWrapper>{!ignoreLoading && isLoading ? <Loader.Basic message={loadingMessage ?? 'Loading...'} /> : children}</S.InnerWrapper>
        </S.Wrapper>
    )
}
/**********************************************************************************************************
 *   COMPONENT END
 **********************************************************************************************************/
